import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { SharedService } from 'src/app/core/services/shared.service';
import { formatNumber } from '@angular/common';
import CryptoJS from 'crypto-js';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-respuesta-pago-ecommerce',
  templateUrl: './respuesta-pago-ecommerce.component.html',
  styleUrls: ['./respuesta-pago-ecommerce.component.scss']
})
export class RespuestaPagoEcommerceComponent implements OnInit, OnDestroy {
  sessionId: string | null = null;
  FAC71CON: string | null = null;
  tipo: string | null = null;

  respuestaPago: any;
  respuestaPagoCarga: boolean = false;

  private queryParamsSubscription?: Subscription;
  private yaConsulto: boolean = false; 

  constructor(
    private route: ActivatedRoute, 
    private dataService: SharedService, 
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      if (this.yaConsulto) {
        console.log('Ya se consultó previamente, evitando re-entrada');
        return;
      }

      this.tipo = params['tipo'] || null;

      if (this.tipo === 'P') {
        this.FAC71CON = params['FAC71CON'] || null;
        console.log('FAC71CON:', this.FAC71CON);
        this.getConsultarTransaccionPlayToPay();
      } else {
        this.sessionId = params['session_id'] || null;
        console.log('Session ID:', this.sessionId);
        this.getConsultarTransaccionCredicorp();
      }

      this.yaConsulto = true; 
    });
  }

  ngOnDestroy(): void {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  getConsultarTransaccionCredicorp() {
    this.respuestaPagoCarga = true;
    let llaves = {
      "LLAVES": [
        {
          "session_id": this.sessionId
        }
      ]
    };
  
    const llavesJsonString = JSON.stringify(llaves);
  
    this.dataService.Ejecutar("api/publicos/ConsultarTransaccionCrediCorp", llavesJsonString).subscribe(
      (datos) => {
        console.log("Datos Credicorp:", datos);
        this.respuestaPago = {
          fecha: datos[0].data.queryDepositResponse.responseData.transactionDate,
          codigoAutorizacion: datos[0].data.queryDepositResponse.responseData.authorizationCode,
          referencia: datos[0].data.queryDepositResponse.responseData.retrievalReference,
          monto: datos[0].data.queryDepositResponse.responseData.totalAmount,
          moneda: datos[0].data.queryDepositResponse.responseData.currency,
          estado: datos[0].data.queryDepositResponse.responseStatus.description,
          mensaje: datos[0].data.queryDepositResponse.message
        };
        this.respuestaPagoCarga = false;
      },
      error => {
        this.respuestaPagoCarga = false;
        Swal.fire({
          html: `
            <div class="row align-items-center" style="width:100%; overflow:auto;">
              <div class="col-4">
                <img src="assets/images/imageerror.png" />
              </div>
              <div class="col-8">
                <h3>Error</h3><br>
                <p>${error}</p>
              </div>
            </div>`
        });
      }
    );
  }

  getConsultarTransaccionPlayToPay() {
    this.respuestaPagoCarga = true;
    const llaves = {
      "LLAVES": [
        { "FAC71CON": this.FAC71CON }
      ]
    };
  
    this.dataService.Ejecutar("api/publicos/ConsultarTransaccionPlaceToPay", JSON.stringify(llaves)).subscribe(
      (datos: any) => {
        let item: any = null;
        if (datos && datos.DATA && Array.isArray(datos.DATA) && datos.DATA.length > 0) {
          item = datos.DATA[0];
        } else if (Array.isArray(datos) && datos.length > 0) {
          item = datos[0];
        } else {
          item = datos || null;
        }
  
        if (!item) {
          this.respuestaPagoCarga = false;
          Swal.fire('Error', 'Respuesta inválida al consultar PlaceToPay', 'error');
          return;
        }
  
        const payment0 = Array.isArray(item.payment) && item.payment.length > 0 ? item.payment[0] : null;
        const statusObj = item.status && Object.keys(item.status).length ? item.status : (payment0 && payment0.status ? payment0.status : {});
  
        const date = statusObj.date || '';
        const reason = statusObj.reason || '';
        const message = statusObj.message || '';
        const rawStatus = (statusObj.status || '').toUpperCase();
  
        const estado = rawStatus === 'APPROVED' ? 'Procesada'
                    : rawStatus === 'REJECTED' ? 'Rechazada'
                    : rawStatus || '';
  
        const authorization = payment0?.authorization || '';
        const reference = payment0?.reference || (item.request?.payment?.reference) || '';
        const amount = payment0?.amount?.from?.total
                     || item.request?.payment?.amount?.total
                     || 0;
        const currency = payment0?.amount?.from?.currency
                      || item.request?.payment?.amount?.currency
                      || '';

        let processUrl = '';
        const fields = item.request?.fields;
        if (Array.isArray(fields)) {
          const f = fields.find((x: any) => x.keyword === '_processUrl_' || x.keyword === '_processUrl');
          if (f) processUrl = f.value;
        }
  
        this.respuestaPago = {
          requestId: item.requestId || item.request?._session_ || '',
          processUrl,
          fecha: date,
          codigoAutorizacion: authorization,
          referencia: reference,
          monto: isNaN(Number(amount)) ? amount : Number(amount),
          moneda: currency,
          estado,             
          mensaje: message,
          razon: reason      
        };
  
        this.respuestaPagoCarga = false;
      },
      (error) => {
        this.respuestaPagoCarga = false;
        console.error('Error al consultar transacción PlaceToPay:', error);
        Swal.fire('Error', 'Ocurrió un error al consultar la transacción PlaceToPay', 'error');
      }
    );
  }

  formatearMoneda(monto: number): string {
    console.log(monto, 'monto');
    return formatNumber(monto, 'en-US', '1.2-2');
  } 

  webCheckoutBCR(requestId: string, login: string, secretKey: string) {
    if (!requestId || !login || !secretKey) {
      console.error('webCheckoutBCR: Faltan parámetros requeridos', { requestId, login, secretKey });
      return;
    }

    const seed = new Date().toISOString();
    const rawNonce = Math.floor(Math.random() * 1000000).toString();
    const nonce = btoa(rawNonce);
    const tranKey = CryptoJS.enc.Base64.stringify(
      CryptoJS.SHA256(rawNonce + seed + secretKey)
    );

    const requestBody = {
      auth: {
        login,
        seed,
        nonce,
        tranKey
      }
    };

    const placeToPayUrl = 'https://checkout-test.placetopay.com/api/session/' + requestId;

    console.log('Consultando PlaceToPay:', placeToPayUrl);
    console.log('Body enviado:', requestBody);

    this.http.post(placeToPayUrl, requestBody).subscribe({
      next: (response: any) => {
        console.log('Respuesta PlaceToPay:', response);

        if (response && response.status) {
          const statusGeneral = (response.status.status || '').toUpperCase();
          const pay0Status = (response.payment?.[0]?.status?.status || '').toUpperCase();

          const statusFinal = pay0Status || statusGeneral;
          const estadoUI = statusFinal === 'APPROVED' ? 'Procesada' : statusFinal;

          this.respuestaPago = {
            fecha: response.status.date || '',
            codigoAutorizacion: response.payment?.[0]?.authorization || '',
            referencia: response.payment?.[0]?.reference || '',
            monto: response.payment?.[0]?.amount?.from?.total || response.request?.payment?.amount?.total || 0,
            moneda: response.payment?.[0]?.amount?.from?.currency || response.request?.payment?.amount?.currency || '',
            estado: estadoUI || '',
            mensaje: response.status.message || ''
          };
        }
      },
      error: (error) => {
        console.error('Error al consultar sesión de pago PlaceToPay:', error);
        
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al consultar la sesión de pago en PlaceToPay.'
        });
      }
    });
  }

  cerrarVentana() {
    window.close();
  }
}